import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import tracking from './utils';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    tracking.track('Page View', {
      path: location.pathname,
    });
  }, [location]);
};

export default usePageTracking;
